// controllers
import { CategoryController } from "controllers";

// HOC
import { withBaseSelect } from "shared/HOC";
import { sortArrayPipe } from "shared/pipes";

// const categories = CategoryController.getCategories();

async function dataStream(callback) {
    const categories = await CategoryController.getCategories();
    callback(sortArrayPipe.transform(categories, 'value'));
  }
  

const CategoriesSelect = withBaseSelect([],dataStream);

export default CategoriesSelect;
